"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var _1 = require(".");
function useScrollAnchor(isOpen) {
    var anchorRef = react_1.useRef(null);
    var followRef = react_1.useRef(null);
    react_1.useEffect(function () {
        var _a;
        var handleScroll = function () {
            _1.setListMenuDomRect(isOpen, followRef, anchorRef);
        };
        var closestScrollableParent = _1.getScrollParent((_a = anchorRef.current) === null || _a === void 0 ? void 0 : _a.parentElement);
        if (closestScrollableParent) {
            closestScrollableParent.addEventListener('scroll', handleScroll);
        }
        window.addEventListener('scroll', handleScroll);
        return function () {
            if (closestScrollableParent) {
                closestScrollableParent.removeEventListener('scroll', handleScroll);
            }
            window.removeEventListener('scroll', handleScroll);
        };
    }, [anchorRef, followRef, isOpen]);
    return [anchorRef, followRef];
}
exports.default = useScrollAnchor;
//# sourceMappingURL=useScrollAnchor.js.map